export default __webpack_public_path__ + "static/media/paypal_inverse.76381cf1.svg";